import t from './PurchaseOrderType.type';
import * as purchaseOrderService from '../../../../services/purchase-order.service';
import { toasterMsg } from '../../../../Components/Toaster/Toaster';
import { imageUrl } from '../../../../Components/helper';

export const fetchPurchaseOrder = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPurchaseOrderService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PURCHASE_ORDER,
        payload: {
          data: res.data,
          searchText: params.searchText,
          isScrolled: params.isScrolled,
        },
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const editPurchaseOrder = (params, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.editPurchaseOrderService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadPurchaseOrder = (params, id) => async () => {
  try {
    const res = await purchaseOrderService.downloadPo(params, id);
    if (res?.code === 200) {
      if (res?.data?.filename) {
        const fileName = res.data.filename.toString();
        const path = res.data.path.split('./static/');
        const fileUrl = `${imageUrl}/${path[1]}`;

        fetch(fileUrl)
          .then((response) => response.blob()) // Convert response to Blob
          .then((blob) => {
            const fileObjectURL = window.URL.createObjectURL(blob);
            const link = document.createElement('a');
            link.href = fileObjectURL;
            link.download = fileName;
            document.body.appendChild(link);
            link.click();
            document.body.removeChild(link);
            window.URL.revokeObjectURL(fileObjectURL); // Clean up
          })
          .catch((error) => console.error('Download error:', error));
      }
    } else {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchDevorder = (devOrderId) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchDevorderColourwaysService(devOrderId);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_MODAL_COLOURWAYSLIST,
        payload: res.data?.colorLibraries || [],
      });
      await dispatch({
        type: t.SET_DEVORDER_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchDevorderSupplier = (data) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchDevorderSupplierService(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_MODAL_SUPPLIERLIST,
        payload: res.data || [],
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchPoTemplate = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPoTemplateService({
      ...params,
      isActive: true,
    });
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_MODAL_PO_TEMPLATE,
        payload: res.data || [],
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchProfile = () => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchProfileService({
      id: 'Personalise',
    });
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PROFILE,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fethcPoDetails = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fethcPoDetailsService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PO_DETAILS,
        payload: res.data,
      });
    } else {
      await dispatch({
        type: t.SET_PO_DETAILS,
        payload: null,
      });
    }
    return true;
  } catch (err) {
    await dispatch({
      type: t.SET_PO_DETAILS,
      payload: null,
    });
    toasterMsg(err.toString(), 'danger');
  }
};

export const emptyData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.EMPTY_PREVIEW,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const createPoPermission = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.createPoPermissionService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_CREATE_PO_PERMISSION,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const addToPurchaseOrder = (data, id, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.addPurchaseOrder(data, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchTradeRef = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchTradeRefService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_TRADE_REF,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getEditedData = (params, id) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.getEditPurchaseOrder(params, id);
    if (res?.code === 200) {
      await dispatch({
        type: t.GET_EDITED_DATA,
        payload: res.data,
      });
      return res.data;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const changingStatus = (id, devId, data, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.postStatus(id, devId, data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res?.data?.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deletePO = (id, devId, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.deletePurchaseOrder(id, devId);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg.toString()), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const postEditedData = (params, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.putEditPurchaseOrder(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      console.log(transactionMsg(res?.data?.errMsg), 'gdsdgfdsf');
      toasterMsg(transactionMsg(res?.data?.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchMaterialPlacementComponent = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchMaterialPlacementComponentService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_MATERIAL_PLACEMENT,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearIndividual = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.GET_EDITED_DATA,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchLegLengths = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchLegLengthsService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_LEG_LENGTH,
        payload: res.data,
      });
      return true;
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchSizes = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchSizesService(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_SZES,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchPODocs = (params, id) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPODocumentsService(params, id);
    if (res?.code === 200) {
      await dispatch({
        type: t.DOCUMENT_LIST,
        payload: res.data,
      });
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const previewData = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPreviewData(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.PREVIEW_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const poPublicData = (devOrderId) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPublicPoData(devOrderId);
    if (res?.code === 200) {
      await dispatch({
        type: t.PREVIEW_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const poPublicDevData = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPublicDevDetails(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.PREVIEW_DEV_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const poPublicPurchaseData = (devOrderId, poId) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPublicPurchasePoData(devOrderId, poId);
    if (res?.code === 200) {
      await dispatch({
        type: t.PREVIEW_DATA,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const clearPreviewData = () => async (dispatch) => {
  try {
    await dispatch({
      type: t.PREVIEW_DATA,
      payload: null,
    });
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const getShipmentDates = (params) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchShipmentDates(params);
    if (res?.code === 200) {
      await dispatch({
        type: t.DATES_LIST,
        payload: res.data,
      });
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const deletePODocumentsService = (params, id, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.deletePODocumentsService(params, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(transactionMsg(res.data.errMsg), 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const putPODocumentsService = (params, payload, id, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.editPODocumentsService(params, payload, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
      return true;
    }
    toasterMsg(res.data.errMsg, 'danger');
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const postPODocuments = (params, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.postPODocumentsService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const markAsCompleteDelivery = (params, qparams, id, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.markComplete(params, qparams, id);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const saveShipmentDate = (params, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.postShipmentDates(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res.data.errMsg, 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updatePOTemplate = (params, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.updatePOTemplateService(params);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const updatePurchaseOrder = (data, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.updatePurchaseOrderService(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(transactionMsg(res.data.errMsg), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchPurchaseOrderHistory = (data) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPurchaseOrderHistoryService(data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PO_HISTORY_DATA,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchPurchaseOrderLog = (devId, data) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchPurchaseOrderLogService(devId, data);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_PO_LOG_DATA,
        payload: res.data,
      });
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const revisePo = (obj, reqObj) => async () => {
  try {
    const res = await purchaseOrderService.revisePoService(obj, reqObj);
    if (res?.code === 200) {
      return { ...obj, ...reqObj };
    }
    toasterMsg(res.data.errMsg.toString(), 'danger');

    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const rejectApprove = (data, transactionMsg) => async () => {
  try {
    const res = await purchaseOrderService.rejectApproveService(data);
    if (res?.code === 200) {
      const msg = transactionMsg(`PURCHASE_ORDER.${res.message}`);
      toasterMsg(msg, 'success');
    } else {
      toasterMsg(res.data.errMsg.toString(), 'danger');
    }
    return true;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const downloadPODoc = (data) => async () => {
  try {
    if (data?.filename) {
      const fileName = data.filename.toString();

      fetch(data?.path)
        .then((response) => response.blob()) // Convert response to a Blob
        .then((blob) => {
          const fileObjectURL = window.URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = fileObjectURL;
          link.download = fileName;
          document.body.appendChild(link);
          link.click();
          document.body.removeChild(link);
          window.URL.revokeObjectURL(fileObjectURL); // Clean up
        })
        .catch((error) => console.error('Download error:', error));
    }
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
  }
};

export const fetchOldPoPreview = (devOrderId, poOrderId) => async (dispatch) => {
  try {
    const res = await purchaseOrderService.fetchOldPoPreviewService(devOrderId, poOrderId);
    if (res?.code === 200) {
      await dispatch({
        type: t.SET_OLD_PO_PREVIEW_DATA,
        payload: res.data,
      });
    }
    return res;
  } catch (err) {
    toasterMsg(err.toString(), 'danger');
    throw err;
  }
};
